import React from 'react'

interface ExpandIconProps {
  stroke?: string
  fill?: string
}

export const ExpandIcon = ({
  stroke = 'var(--color-iconSecondary)',
  fill = 'currentColor',
}: ExpandIconProps) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
      fill={fill}
    />
    <path
      d="M12.6667 8.5H12.5C11.0999 8.5 10.3998 8.5 9.86502 8.77248C9.39462 9.01217 9.01217 9.39462 8.77248 9.86502C8.5 10.3998 8.5 11.0999 8.5 12.5V12.6667M12.6667 23.5H12.5C11.0999 23.5 10.3998 23.5 9.86502 23.2275C9.39462 22.9878 9.01217 22.6054 8.77248 22.135C8.5 21.6002 8.5 20.9001 8.5 19.5V19.3333M23.5 12.6667V12.5C23.5 11.0999 23.5 10.3998 23.2275 9.86502C22.9878 9.39462 22.6054 9.01217 22.135 8.77248C21.6002 8.5 20.9001 8.5 19.5 8.5H19.3333M23.5 19.3333V19.5C23.5 20.9001 23.5 21.6002 23.2275 22.135C22.9878 22.6054 22.6054 22.9878 22.135 23.2275C21.6002 23.5 20.9001 23.5 19.5 23.5H19.3333"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
